import { PropTypes } from '@elliemae/ds-props-helpers';
import type { DSPropTypesSchema, GlobalAttributesT, XstyledProps, ValidationMap } from '@elliemae/ds-props-helpers';
import type { DSButtonT } from '../SharedButtonBaseline/react-desc-prop-types.js';
import { DSButtonPropTypes } from '../SharedButtonBaseline/react-desc-prop-types.js';
import { DSButtonV3DataTestId } from './DSButtonV3Definitions.js';

export namespace DSButtonV3T {
  export interface DefaultProps extends DSButtonT.DefaultProps {}

  export interface OptionalProps extends DSButtonT.OptionalProps {}

  export interface RequiredProps extends Omit<DSButtonT.RequiredProps, 'isV3'> {}

  export interface Props
    extends
      Partial<DefaultProps>,
      OptionalProps,
      Omit<GlobalAttributesT<HTMLButtonElement>, keyof DefaultProps | keyof OptionalProps | keyof RequiredProps>,
      XstyledProps,
      RequiredProps {}

  export interface InternalProps
    extends
      DefaultProps,
      OptionalProps,
      Omit<GlobalAttributesT<HTMLButtonElement>, keyof DefaultProps | keyof OptionalProps | keyof RequiredProps>,
      XstyledProps,
      RequiredProps {}
}

export const DSButtonV3PropTypes = {
  ...DSButtonPropTypes,
  'data-testid': PropTypes.string.description('Root element data-testid.').defaultValue(DSButtonV3DataTestId.ROOT),
} as DSPropTypesSchema<DSButtonV3T.Props>;

export const DSButtonV3PropTypesSchema = DSButtonV3PropTypes as unknown as ValidationMap<DSButtonV3T.Props>;
